import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router';
Vue.config.productionTip = false
import VueElementLoading from "vue-element-loading";
Vue.component("VueElementLoading", VueElementLoading);



new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
